namespace Matrix.Data {
    export interface TestForm {
        TestCode: Serenity.StringEditor;
        Description: Serenity.StringEditor;
        Enabled: Serenity.BooleanEditor;
        TestTypeCode: Serenity.StringEditor;
        Priority: TestPriorityEditor;
        Script: CodeEditor;
        LastRunBatchId: Serenity.IntegerEditor;
        LastResultCode: Serenity.StringEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class TestForm extends Serenity.PrefixedContext {
        static formKey = 'Data.Test';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!TestForm.init)  {
                TestForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.BooleanEditor;
                var w2 = TestPriorityEditor;
                var w3 = CodeEditor;
                var w4 = s.IntegerEditor;
                var w5 = StaticTextBlock;
                var w6 = ReadOnlyDateTime;

                Q.initFormType(TestForm, [
                    'TestCode', w0,
                    'Description', w0,
                    'Enabled', w1,
                    'TestTypeCode', w0,
                    'Priority', w2,
                    'Script', w3,
                    'LastRunBatchId', w4,
                    'LastResultCode', w0,
                    'CreatedBy', w5,
                    'CreatedWhen', w6,
                    'UpdatedBy', w5,
                    'UpdatedWhen', w6,
                    'Version', w5
                ]);
            }
        }
    }
}
